<template>
	<div>
		<action-sidebar
			title=""
			:value="true"
			:width="485"
			@close-modal="closeModal"
		>
			<div class="new-type-form-container">
				<div
					class="title-container"
					:style="`color:${$appColors.primary};`"
				>
					<h2>José Juan</h2>
					<output>100 Puntos</output>
				</div>
				<assignment-presents-component/>
				<div class="modal-btn-container">
					<app-button
						class="close-btn"
						:style="`color:${$appColors.error};`"
						text="Cerrar"
						@click="closeModal"
					/>
				</div>
			</div>
		</action-sidebar>
	</div>
</template>
<script>
import actionSidebar from '@/components/shared/action-sidebar';
import appButton from '@/components/shared/app-button';
import assignmentPresentsComponent from '@/components/configuration/employees/assignmentPresentsComponent';

function closeModal() {
	this.goTo('employees');
}

export default {
	name: 'assignment-presents',
	components: {
		actionSidebar,
		appButton,
		assignmentPresentsComponent,
	},
	methods: {
		closeModal,
	},
};
</script>
<style lang="scss" scoped>
.new-type-form-container {
	background-color: color(gray-light);
	height: 100%;

	.title-container {
		align-items: center;
		border-bottom: 1px solid color(gray-slider);
		display: flex;
		font-family: font(bold);
		font-size: size(xlarge);
		justify-content: space-between;
		padding: 10px 25px;

		h2 {
			font-size: size(xlarge);
		}
	}

}

.modal-btn-container {
		background-color: white;
		bottom: 0;
		display: flex;
		justify-content: center;
		left: 0;
		padding: 20px;
		position: fixed;
		width: 100%;
		
		.close-btn {
			border-radius: 5px;
			color: white;
			margin: 0 5px;
			padding: 5px 30px;
		}
	}
</style>


// WEBPACK FOOTER //
// src/components/configuration/employees/assignmentPresents.vue